module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC7SURBVEhL5dQhDsJAFIThTXAYFJIjoPGcgoSToDgF3KMCj0RzAywKg8AA/wtMQshC+96u6yRfsmmbmaxp6l2WWL2O9TPHDXcs7EHNTHHB4+2KGapkjBNULmdMUJQhDvgulyNGCGWABrniTzvYt+5skSvMsW/DWSNXauxdUf6VS3ikS7m4Rzzl0nkkUi6um3iGXMWWyC06j0TKpXWkpFx+jtQol9ab5LKBCuxcPXtowM7VY/9/Ddi5F0npCXCItcWcDEKlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-evergreen/dark/24.png
// module id = 2014
// module chunks = 2